











































import slugify from '@/lib/slugify'

export default {
  props: {
    clientId: String
  },
  data: function() {
    return {
      project: {
        slug: '',
        name: ''
      }
    }
  },
  watch: {
    'project.name': function() {
      this.project.slug = slugify(this.project.name)
    }
  },
  methods: {
    saveProject() {
      this.$api.clientAdmin
        .CreateProject(this.project)
        .then(() => this.$router.push({ name: 'settings-projects-list' }))
    }
  }
}
